import React, { useState } from 'react';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollingScreenshotPreview } from '@/components/ui/scrolling-screenshot-preview';
import { Monitor, Info } from 'lucide-react';

interface ProjectScreenshotPreviewProps {
  src: string;
  alt?: string;
  enableAutoScroll?: boolean;
  onToggleAutoScroll?: (enabled: boolean) => void;
  className?: string;
  height?: string | number;
}

export const ProjectScreenshotPreview: React.FC<ProjectScreenshotPreviewProps> = ({
  src,
  alt = 'Screenshot do projeto',
  enableAutoScroll = true,
  onToggleAutoScroll,
  className,
  height = '500px'
}) => {
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(enableAutoScroll);

  const handleToggle = (enabled: boolean) => {
    setAutoScrollEnabled(enabled);
    onToggleAutoScroll?.(enabled);
  };

  return (
    <Card className={className}>
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="flex items-center gap-2 text-lg">
              <Monitor className="w-5 h-5 text-blue-500" />
              Visualização do Site
            </CardTitle>
            <CardDescription className="flex items-center gap-1">
              <Info className="w-3 h-3" />
              Preview do screenshot com rolagem automática
            </CardDescription>
          </div>
          
          <div className="flex items-center space-x-3 bg-muted/50 rounded-lg px-3 py-2">
            <div className="space-y-1">
              <Label htmlFor="auto-scroll" className="text-sm font-medium cursor-pointer">
                Auto-scroll
              </Label>
              <p className="text-[10px] text-muted-foreground">
                Mostra todo o site automaticamente
              </p>
            </div>
            <Switch
              id="auto-scroll"
              checked={autoScrollEnabled}
              onCheckedChange={handleToggle}
              className="data-[state=checked]:bg-blue-600"
            />
          </div>
        </div>
      </CardHeader>
      
      <CardContent>
        <ScrollingScreenshotPreview
          src={src}
          alt={alt}
          enableAutoScroll={autoScrollEnabled}
          height={height}
        />
        
        <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-950/20 rounded-lg border border-blue-100 dark:border-blue-900/30">
          <p className="text-xs text-blue-800 dark:text-blue-200">
            💡 <strong>Dica:</strong> Para screenshots longos, o auto-scroll rola a imagem automaticamente
            mostrando todo o conteúdo. Você pode pausar e ajustar a velocidade conforme necessário.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
